<template>
	<Modal 
	:title="'FILIAIS'"
	:loading="loading"
	@close="close">

		<div v-if="!editting">
			<button class="button-edit new-user" @click="editting = 'new'">
				<i class="fa fa-plus"></i> Nova filial
			</button>

            <br><br>

			<Table 
			:loading="loading"
			:headers="headers" 
			:modifiers="modifiers" 
			:ordering="[]" 
			:list="list" 
			:page="0"
			:per_page="0" 
			:total="total" 
			v-slot="{item}">

				<button class="button-edit" @click="editting = item" title="Editar">
					<i class="fa fa-fw fa-edit"></i>
				</button>

				<button class="button-remove" @click="remove(item.id)" title="Excluir">
					<i class="fa fa-fw fa-trash"></i>
				</button>

			</Table>
		</div>

		<AdminCompanyDocumentForm 
        v-if="!!editting" 
        :current="editting" 
        :company="current" 
        @load="load" 
        @close="editting = false" />

	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import Table from "@/components/Table";
import AdminCompanyDocumentForm from "./AdminCompanyDocumentForm.vue";

export default {
    name: "AdminCompanyDocument",

    props: [ "current" ],

    components: { Modal, Table, AdminCompanyDocumentForm },

    data() {
        return {
            loading: false,

            editting: false,

            list: [],
            total: 0,

            modifiers: {},
            headers: {
                name: "Nome",
                document: "CNPJ"
            }
        }
    },

    mounted: function() {
		this.load();
	},


	activated: function() {
		this.load();
	},


    methods: {
        async load() {
            this.list = [];

			this.loading = true;
			let res = await Api.post_admin("company/get-documents", { company_id: this.current.id });
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				this.close();
			}

            this.list = res.data;
            this.total = res.data.length;
        },

        async remove(id) {
            const confirm = await this.$alert.confirm("Você tem certeza que deseja excluir esse documento?");
			if (!confirm) return;

            this.loading = true;
			let res = await Api.post_admin("company/remove-document", { id: id });
            if (res.error) {
                this.$notification.error(res.data);
            } else {
                this.$notification.success("Removido com sucesso.");
            }
            
            this.load();
        },

        close() {
            this.$parent.show_documents = false;
        }
    }
}
</script>

<style scoped>

</style>